export default "__VITE_ASSET__Chu86LUH__"